document.addEventListener("DOMContentLoaded", function() {
  // 只针对打了 comingsoon tag 的产品页
  if (document.body.classList.contains("product-comingsoon")) {
    // 延迟删除，确保 Afterpay JS 已生成元素
    setTimeout(() => {
      // 删除 Afterpay 元素
      const afterpay = document.querySelector(".afterpay-paragraph");
      if (afterpay) afterpay.remove();

      // 隐藏价格元素
      const prices = document.querySelectorAll(".price, .money, .modal_price");
      prices.forEach(p => p.style.display = "none");
    }, 500); // 0.1秒延迟
  }
});
document.addEventListener("DOMContentLoaded", function() {
  if (document.body.classList.contains("product-comingsoon")) {
    setTimeout(() => {
      // 删除 Afterpay 元素
      const afterpay = document.querySelector(".afterpay-paragraph");
      if (afterpay) afterpay.remove();

      // 找到价格元素
      const priceElements = document.querySelectorAll(".price, .money, .modal_price");
      priceElements.forEach(el => {
        // 替换内容为 Price Coming Soon
        el.textContent = "Coming Soon";
        el.style.display = "inline-block"; // 保持原来的布局
        el.style.fontWeight = "bold";
        el.style.fontSize = "1.7rem"; // 可根据主题调整
        el.style.color = "#ff0000";   // 红色醒目，可改
      });
    }, 500); // 延迟，确保 Afterpay 已渲染
  }
});
document.addEventListener("DOMContentLoaded", function() {

  if (window.location.pathname.includes('/collections/2026-harley-davidson-all-family-models')) {

    document.querySelectorAll('.price, .product-price, .money').forEach(function(el) {

      let text = el.innerText.trim().toLowerCase();

      // 只处理纯价格（比如 $80,495 没有 from 的）
      if (!text.includes('from')) {

        if (!el.closest('.was-price') && !el.classList.contains('compare-at-price')) {
          el.innerText = 'From ' + el.innerText.trim();
        }

      }

    });

  }

});